<template>
  <b-container :fluid="true">
    <b-row align-h="center"
           class="mb-2">

      <extended-checkbox-group v-model="checkedReviewers"
                               :options="checkboxReviewers"
                               class="container-fluid checkbox-margin"
                               group-class="checkbox-flex flex-wrap justify-center"/>
    </b-row>
  </b-container>
</template>

<script>
  import ExtendedCheckboxGroup from '@/components/ExtendedCheckboxGroup';

  export default {
    name: 'FinalGradeSelectReviewersCheckboxes',
    components: { ExtendedCheckboxGroup },
    props: {
      reviewers: {
        type: Array,
        required: true,
      },
    },
    data() {
      return { checkedReviewers: [] };
    },
    computed: {
      maxReviewerNameWidth() {
        const namesWidths = this.reviewers.map((reviewer) => this.userFullName(reviewer).length);
        return Math.max(...namesWidths);
      },
      checkboxReviewers() {
        const defaultPaddingOffset = '2rem';
        return this.reviewers.map(
          (reviewer) => ({
            text: this.userFullName(reviewer),
            name: this.reviewerCheckboxName(reviewer),
            style: `min-width: calc(${this.maxReviewerNameWidth}ch + ${defaultPaddingOffset});`,
          }),
        );
      },
    },
    methods: {
      userFullName({ first_name, last_name, reviewerProposalCounter }) {
        // eslint-disable-next-line camelcase
        return `${first_name} ${last_name} (${reviewerProposalCounter || 0})`;
      },
      reviewerCheckboxName(reviewer) {
        const { reviewerProposalCounter, ...reviewerWithoutProposalCounter } = reviewer;
        return reviewerWithoutProposalCounter;
      },
    },
    watch: {
      checkedReviewers: {
        handler() {
          this.$emit('change', this.checkedReviewers);
        },
      },
    },
  };
</script>

<style lang="scss"
       scoped>
  $make-bold-without-resizing: 0 0 1px $color-blue-info;

  ::v-deep .checkbox-flex {
    display: flex;
    gap: 1rem;
  }

  .checkbox-margin {
    margin-bottom: 0;
  }

  ::v-deep .flex-wrap label {
    background-color: white;
    margin-left: 0;
    max-width: max-content;
  }

  ::v-deep .flex-wrap label:hover {
    color: $color-blue-info;
    text-shadow: $make-bold-without-resizing;
  }
</style>
